<template>
  <div class="nav-bar">
    <div class="top-bar">
      <div class="customer-info">
        <div class="customer-name">היי {{ householdName }}</div>
        <div class="subscription-state" :class="subscriptionStateVariant" @click="subscriptionStateClicked">
          {{ subscriptionStateText }}
        </div>
      </div>
      <div class="menu">
        <navigation-menu-item title="התזרים שלי" v-on:navigate="closeModal" target-path="home"/>
        <balance-page-menu-item v-on:navigate="closeModal"/>
        <navigation-menu-item title="חשבונות מחוברים" v-on:navigate="closeModal" target-path="credentials"/>
        <account-settings-menu-item v-on:navigate="closeModal"/>
      </div>
    </div>
    <div class="bottom-bar">
      <navigation-button :on-click="addMember" :button-text="'הזמנת שותפ.ה לתזרים'">
        <img :src="require('@/assets/nav/add-member-icon.svg')"/>
      </navigation-button>
      <navigation-button :on-click="openChat" :button-text="'צ׳אט עם הצוות'">
        <img :src="require('@/assets/nav/chat-icon.svg')"/>
      </navigation-button>
      <navigation-button :on-click="openFaq" :button-text="'מרכז המידע'">
        <img :src="require('@/assets/nav/help-icon.svg')"/>
      </navigation-button>
      <navigation-button :on-click="openReferralPopup" :button-text="'שיתוף עם החברים'">
        <img :src="require('@/assets/nav/gift-icon.svg')"/>
      </navigation-button>
      <navigation-button :on-click="redirectToLogin" :button-text="'יציאה'">
        <img :src="require('@/assets/nav/exit-icon.svg')"/>
      </navigation-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';

import router from '../../router';
import NavigationButton from './NavigationButton.vue';
import Intercom from '../../Intercom';
import { SUBSCRIPTION_STATES } from '../../constants/subscription-state';
import trialUtils from '../../pages/responsive-pages/authenticated/trial/trial-utils';
import Segment from '../../Segment';
import ModalBus from '../../event-bus/modal-bus';
import ReferralPopup from '../../pages/responsive-pages/authenticated/referral/ReferralPopup.vue';
import config from '../../config';
import AccountSettingsMenuItem from './AccountSettingsMenuItem.vue';
import NavigationMenuItem from './NavigationMenuItem.vue';
import BalancePageMenuItem from './BalancePageMenuItem.vue';

export default {
  name: 'NavigationMenu',
  components: {
    BalancePageMenuItem,
    NavigationMenuItem,
    AccountSettingsMenuItem,
    NavigationButton,
  },
  props: {
    closeModal: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters('session', ['householdName']),
    ...mapState('session', ['hasDiscountApiAccount']),
    ...mapState('subscriptionState', ['subscriptionState']),
    ...mapGetters('subscriptionState', ['daysLeft', 'trialPeriod']),
    ...mapState('promotions', ['eligibleForDiscountPromotion']),
    ...mapState('session', ['inviteToken']),
    addMemberLink() {
      return `${config.get().elsaPublicUrl}/invite?accessToken=${this.inviteToken}`;
    },
    addMemberMessage() {
      return encodeURIComponent(`היי! *נרשמתי ל-riseup!* אני מחכה לך בתזרים המשותף שלנו 🎯 כל מה שצריך לעשות בשביל להצטרף אליי זה *ללחוץ על הלינק המצורף* 👇 ${this.addMemberLink}`);// eslint-disable-line
    },
    subscriptionStateText() {
      switch (this.subscriptionState) {
        case SUBSCRIPTION_STATES.PRE_TRIAL: return '';
        case SUBSCRIPTION_STATES.TRIAL: return this.trialCounterText;
        case SUBSCRIPTION_STATES.DORMANT_AFTER_CANCELED: return 'המנוי לא פעיל';
        case SUBSCRIPTION_STATES.DORMANT_AFTER_TRIAL: return 'המנוי לא פעיל';
        case SUBSCRIPTION_STATES.FREE: return '';
        case SUBSCRIPTION_STATES.SUBSCRIBED: return '';
        case SUBSCRIPTION_STATES.CANCELED: return 'חיוב אחרון נכשל';
        default: return '';
      }
    },
    subscriptionStateVariant() {
      switch (this.subscriptionState) {
        case SUBSCRIPTION_STATES.PRE_TRIAL: return 'warning';
        case SUBSCRIPTION_STATES.TRIAL: return trialUtils.periodVariant(this.trialPeriod);
        case SUBSCRIPTION_STATES.DORMANT_AFTER_CANCELED: return 'danger';
        case SUBSCRIPTION_STATES.DORMANT_AFTER_TRIAL: return 'danger';
        case SUBSCRIPTION_STATES.FREE: return 'warning';
        case SUBSCRIPTION_STATES.SUBSCRIBED: return 'warning';
        case SUBSCRIPTION_STATES.CANCELED: return 'danger';
        default: return 'warning';
      }
    },
    trialCounterText() {
      return `${trialUtils.humanizeDays(this.daysLeft)} לתקופת הניסיון`;
    },
  },
  methods: {
    ...mapActions('login', ['logout']),
    subscriptionStateClicked() {
      Segment.trackUserInteraction('NavigationMenu_SubscriptionStatusClicked', { trialPeriod: this.trialPeriod });
      this.redirectToAccountSettings();
    },
    redirectToCashflow() {
      router.push({ path: '/home' });
      this.closeModal();
    },
    openFaq() {
      window.open('https://intercom.help/riseupisrael/he', '_blank');
      this.closeModal();
    },
    redirectToLogin() {
      this.logout();
      window.location.href = '/login?redirectTo=sr';
      this.closeModal();
    },
    openChat() {
      Intercom.show();
      this.closeModal();
    },
    openReferralPopup() {
      Segment.trackUserInteraction('NavigationMenu_ReferFriendClicked');
      this.closeModal();
      ModalBus.$emit('open', {
        component: ReferralPopup,
      });
    },
    addMember() {
      Segment.trackUserInteraction('InviteMemberClicked');
      window.open(`https://api.whatsapp.com/send?text=${this.addMemberMessage}`, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../scss/mixins';

  .nav-bar {
    min-height: 100%;
    background: $riseup_white;
    border-radius: 5px 0 0 5px;
    box-shadow: -2px 0 5px 0 rgba(0, 0, 0, 0.22);

    .top-bar {
      .customer-info {
        padding-right: 30px;
        border-bottom: 1px solid $riseup_gray_0;

        .customer-name {
          font-family: GretaSans;
          padding-top: 30px;
          font-size: 24px;
          font-weight: bold;
          color: $riseup_black;
        }
        .subscription-state {
          margin: 8px 0 22px 0;
          font-size: 20px;
          text-decoration: underline;
          cursor: pointer;

          &.warning {
            color: $riseup_mustard;
          }

          &.danger {
            color: $riseup_coral;
          }
        }
      }

      .menu {
        padding: 30px 30px 0 30px;
        border-bottom: 1px solid $riseup_gray_0;

        .navigation-link {
          display: flex;
          align-items: center;
          margin-bottom: 30px;
          font-size: 20px;
          cursor: pointer;

          .icon {
            margin-right: 10px;
          }
        }
      }
    }

    .bottom-bar {
      padding: 15px 25px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/base-components/app-header/NavigationMenu.vue